import Table from '../Table/index'
import Filter from '../Table/Filter'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faVial } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import { filter } from 'rxjs/operators'
import loadingSVG from '../../media/loading.svg'
import _ from 'lodash'

const columnLayout = [
  // {
  //   field: 'checkbox',
  //   header: '',
  //   type: 'checkbox',
  //   width: '40px',
  //   fieldStyle: 'justify-center'
  // },
  {
    field: 'companyUuid',
    header: 'Id',
    type: 'id',
    style: 'ph3',
    fieldStyle: 'ph3',
    sortable: true,
  },
  // {
  //   field: 'shipmentId',
  //   header: 'Shipment',
  //   type: 'text',
  //   style: 'ph2',
  //   fieldStyle: 'ph2'
  // },
  {
    field: 'customer.name',
    header: 'Customer',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2',
    sortable: true,
  },
  {
    field: 'claimId',
    header: 'Claim Id',
    type: 'text',
    groupHeader: 'Claim',
    style: 'bg-light-yellow ph2',
    fieldStyle: 'ph2',
    sortable: true,
  },
  {
    field: 'claimedDate',
    header: 'Claim Date',
    type: 'date',
    groupHeader: 'Claim',
    style: 'bg-light-yellow tc',
    fieldStyle: 'justify-center',
    sortable: true,
  },
  {
    field: 'lab.name',
    header: 'Lab',
    type: 'text',
    groupHeader: 'Referee @ 12%',
    style: 'bg-light-green pr2 pl3',
    fieldStyle: 'ph2',
    sortable: true,
  },
  {
    field: 'refereeSentDate',
    header: 'Sent',
    type: 'date',
    groupHeader: 'Referee @ 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'justify-center',
    sortable: true,
  },
  {
    field: 'refereeMoisturePercent',
    header: 'M',
    type: 'textInput',
    groupHeader: 'Referee @ 12%',
    width: '60px',
    style: 'bg-light-green tc',
    childClass: 'tc pv1 ml1',
  },
  {
    field: 'refereeProtein12Percent',
    header: 'P',
    type: 'textInput',
    groupHeader: 'Referee @ 12%',
    width: '60px',
    style: 'bg-light-green tc',
    childClass: 'tc pv1',
  },
  {
    field: 'refereeFiber12Percent',
    header: 'F',
    type: 'textInput',
    width: '60px',
    groupHeader: 'Referee @ 12%',
    style: 'bg-light-green tc',
    childClass: 'tc pv1',
  },
  {
    field: 'refereeFee',
    header: 'Fee',
    type: 'textInput',
    width: '60px',
    groupHeader: 'Referee @ 12%',
    style: 'bg-light-green tc',
    childClass: 'tc pv1',
  },
  {
    field: 'settlementRemarks',
    header: 'Remarks',
    type: 'textInput',
    groupHeader: 'Referee @ 12%',
    width: '200px',
    style: 'bg-light-green',
    fieldStyle: '',
    childClass: 'pv1',
  },
  {
    field: 'refereeFile',
    header: 'File',
    type: 'fileUpload',
    groupHeader: 'Referee @ 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'justify-center',
  },
]

const AllSamples = (props) => {
  const data = props?.shipments?.rawData
  const loading = props?.shipments?.loading
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='relative f5 white' icon={faVial} style={{top:-2}}/>
          <div className='pl2 fw7 f6 white'>Claims Awaiting Referee </div>
          <div className='h2'></div>
        </div>
        <div className='flex'>
        <Filter _view={'claimsAwaitingReferee'}/>
          {/* <div className='pv2 ph3 bg-evonik-light-purple br2 white f6 fw5'>
            Attach File to Selected
          </div> */}
          <SubmitButton id={'inc'} className='' 
            responseId='inc'
            defaultChild={ props => (
              <div className='ml2 pv2 ph3 bg-evonik-light-purple br2 white f6 fw5 pointer '
                onClick={e => Dispatch.nextAction('shipments.save')}
              >
                Save
              </div>
            )}
            loadingChild={ props => (
                <div className='mh3 ' style={{width:40, height: 30}}>
                  <img className='w-100 h-100' src={loadingSVG} alt='loading'/>
                </div>
            )}
            errorChild={ props => (
              <div className='pl3 f7 fw4 red tr pointer'>Error</div>
            )}
            loadingStream={
              Dispatch.getAction('Request.saveShipments')
                .pipe(
                )
              }
            successStream={
              Dispatch.getAction('Response.saveShipments')
                .pipe(
                  filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipments) || !_.isNil(e.data.upsertShipments) ))),
                )
              }
            errorStream={
              Dispatch.getAction('Response.saveShipments')
                .pipe(
                  filter(e => !_.isNil(e.errors)),
                )}
          />
        </div>
      </div>
      <div className='w-100 flex' style={{background: '#f5f3f5'}}>
        <Table _tableName={'awaitingRefree'} _shipments={data} _loading={loading} _columnLayout={columnLayout} {...props}/>
      </div>
    </div>
  )
}

export default AllSamples